import {
  REQUEST_STATUS_COMPLETED,
  REQUEST_STATUS_FAILED,
  REQUEST_STATUS_IN_PROGRESS,
  POLLING_ERROR_POST_INVALID_RESPONSE,
  executePolling,
} from '../../../../../share/util/api/polling';
import apiService from '../../../../../share/util/api/service';
import WS45Dialog from '../Requirement045Dialog';
import logWrapper from '../../../../../share/logWrapper';
import requirement045Utils from './Requirement045Utils';

/**
 * [obd] メモリクリア
 * [diag] メモリクリア
 * @param {instance} self 呼び出し元this
 */
export async function memoryClear(self) {
  try {
    self.isLoading = true;
    switch (self.workSupportId) {
      case 4501:
        await handleObdMemoryClear(self);
        break;

      case 12501:
        await handleDiagMemoryClear(self);
        break;

      default:
        throw new Error(`Unsupported workSupportId: ${self.workSupportId}`);
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.MEMORY_CLEAR, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * OBD メモリクリア処理
 * @param {instance} self 呼び出し元this
 */
async function handleObdMemoryClear(self) {
  const response = await requirement045Utils.doPolling(
    self,
    apiService.OBD,
    {},
    `/netApps/${self.netAppId}/obd/${self.obdDataId}/clearDtc`,
    `/netApps/${self.netAppId}/requests/`
  );

  if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
    const clearResult = response.data.results.find(item => item.system_name === self.systemNo);

    if (clearResult?.is_clear_dtc_success) {
      self.dialog.phase = WS45Dialog.PHASE.DIAG_CODE_DELETE_SUCCESS;
    } else if (clearResult?.error_code === "execute_error") {
      self.dialog.phase = WS45Dialog.PHASE.DIAG_CODE_DELETE_FAILURE;
    } else {
      throw new Error(`Invalid error_code: ${clearResult?.error_code}`);
    }
  } else {
    throw new Error(`Invalid response: ${response}`);
  }
}

/**
 * DIAG メモリクリア処理
 * @param {instance} self 呼び出し元this
 */
async function handleDiagMemoryClear(self) {
  const response = await executePolling(
    self,
    async () => apiService.postCall(apiService.DIAG, `/netApps/${self.netAppId}/systems/${self.systemId}/clearDtc`),
    async () => apiService.getCall(apiService.DIAG, `/pairings/${self.netAppId}`),
    (errorType) => { errorType; self.showUnexpectedError(); },
    (postApiResponse) => {
      if (postApiResponse?.data?.status) return "";
      logWrapper.log("Post Response Check Action: status is invalid.", postApiResponse?.data, true);
      return POLLING_ERROR_POST_INVALID_RESPONSE;
    },
    (getApiResponse) => {
      if (getApiResponse.data.is_clear_dtc_completed) {
        if (getApiResponse.data.err_code !== 0 || getApiResponse.data.err_msg) {
          return REQUEST_STATUS_FAILED;
        }
        return REQUEST_STATUS_COMPLETED;
      }
      return REQUEST_STATUS_IN_PROGRESS;
    },
    (result) => self.validateErrorResult(result),
    (result) => self.validateErrorResult(result)
  );

  if (response) {
    await self.getMemoryClearResult();
  } else {
    throw new Error("Unexpected error occurred: No response");
  }
}

/**
 * [diag] メモリクリアGet処理
 * @param {instance} self 呼び出し元this
 */
export async function getMemoryClearResult(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI GETのみ
    const response = await requirement045Utils.doSyncRequest(
      self,
      apiService.DIAG,
      `/diagDtc/clearDtcResult/${self.netAppId}`,
    );
    if (response) {
      // 正常終了
      const clearResult = response.data.results.find(item => item.system_name === self.systemId);
      if (clearResult.is_clear_dtc_success) {
        // 消去成功
        self.dialog.phase = WS45Dialog.PHASE.DIAG_CODE_DELETE_SUCCESS;
        return;
      }
      // 消去失敗 : error_code により処理を分岐
      if (clearResult.error_code === "execute_error") {
        self.dialog.phase = WS45Dialog.PHASE.DIAG_CODE_DELETE_FAILURE;
      } else {
        throw new Error(`Invalid error_code: ${clearResult.error_code}`);
      }
    } else {
      throw new Error('Unexpected error occurred: No response');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.GET_MEMORY_CLEAR_RESULT, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

export default {
  memoryClear,
  handleObdMemoryClear,
  handleDiagMemoryClear,
  getMemoryClearResult
};